import { createSlice } from '@reduxjs/toolkit';
import {
  AddLinksAction,
  DeleteTrialLinkAction,
  LoadInfoAction,
  SetFormFieldAction,
  SetInfoAction,
  SetIsLinksLoadingAction,
  SetIsLoadingInfoAction,
  SetIsLoadPersonalSubscriptionPriceAction,
  SetLinksAction,
  SetPersonalSubscriptionPriceAction,
  TrialLinksState,
} from '$store/trialLinks/interface';
import { RootState } from '$store/rootReducer';

const initialState: TrialLinksState = {
  links: [],
  isLinksLoading: false,
  isLoadingInfo: false,
  personalSubscriptionPrice: 0,
  isLoadingPersonalSubscriptionPrice: true,
  form: {
    name: '',
    limit: 0,
    expirationDays: 0,
    periodDays: 3,
  },
  info: null,
};

export const { actions, reducer } = createSlice({
  name: 'trialLinks',
  initialState,
  reducers: {
    setIsLinksLoading(state, action: SetIsLinksLoadingAction) {
      state.isLinksLoading = action.payload;
    },
    setFormField(state, action: SetFormFieldAction) {
      state.form[action.payload.name] = action.payload.value;
    },

    loadPersonalSubscriptionPrice() {},
    clearForm(state) {
      state.form = initialState.form;
    },
    setIsLoadPersonalSubscriptionPrice(
      state,
      action: SetIsLoadPersonalSubscriptionPriceAction,
    ) {
      state.isLoadingPersonalSubscriptionPrice = action.payload;
    },
    setPersonalSubscriptionPrice(state, action: SetPersonalSubscriptionPriceAction) {
      state.personalSubscriptionPrice = action.payload;
    },
    loadLinks() {},
    addLink(state, action: AddLinksAction) {
      state.links = [action.payload, ...state.links];
    },
    setLinks(state, action: SetLinksAction) {
      state.links = action.payload;
    },
    createTrialLink() {},
    removeTrialLink(state, action: DeleteTrialLinkAction) {
      state.links = state.links.filter((link) => link.id !== action.payload);
    },
    deleteTrialLink(_, action: DeleteTrialLinkAction) {},
    loadInfo(state, action: LoadInfoAction) {},
    setIsLoadingInfo(state, action: SetIsLoadingInfoAction) {
      state.isLoadingInfo = action.payload;
    },
    setInfo(state, action: SetInfoAction) {
      state.info = action.payload;
    },
    clearInfo(state) {
      state.info = null;
    },
    activate() {},
    attachCardConfirm() {},
  },
});

export const trialLinksSelector = (state: RootState) => state.trialLinks;
export const trialLinksFormSelector = (state: RootState) => state.trialLinks.form;
export const trialLinksInfoSelector = (state: RootState) => state.trialLinks.info;
export const trialLinksIsLoadingInfoSelector = (state: RootState) =>
  state.trialLinks.isLoadingInfo;
export const personalSubscriptionPriceSelector = (state: RootState) =>
  state.trialLinks.personalSubscriptionPrice;
export const isLoadingPersonalSubscriptionPriceSelector = (state: RootState) =>
  state.trialLinks.isLoadingPersonalSubscriptionPrice;

export { reducer as trialLinksReducer, actions as trialLinksActions };
